import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  UiArguments,
} from "shared/provider-webworker";

import { ReplicaLookupService } from "../../impl/ReplicaLookupService";
import { IBlotterDefinitionPromiseLookupService } from "../IBlotterDefinitionPromiseLookupService";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

const ENCODABLE_TYPE_ERRORS: string = "com.bcdfx.broker.ErrorsImpl";
@Injectable()
export class BlotterDefinitionReplicaLookupService
  extends ReplicaLookupService<string, CubiqTS.BlotterDefinitionImpl>
  implements IBlotterDefinitionPromiseLookupService
{
  constructor(protected factory: ClientMessageBrokerFactory) {
    super(factory, CubiqTS.BlotterDefinitionImpl, "BlotterDefinitionImpl");
  }

  getBlotterDefinition(code: string): Promise<CubiqTS.BlotterDefinitionImpl> {
    let request = new UiArguments("getBlotterDefinition");
    let arg1 = new FnArg(code, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, this.VALUE);
  }

  getMyBlotterDefinitions(): Promise<Array<CubiqTS.BlotterDefinitionImpl>> {
    let request = new UiArguments("getMyBlotterDefinitions");
    request.args = [];
    return this.broker.runOnService(request, this.VALUE);
  }

  deleteItemsByIds(ids: string[]): Promise<boolean> {
    let request = new UiArguments("deleteItemsByIds");
    let arg1 = new FnArg(ids, PRIMITIVE);
    request.args = [arg1];
    return this.runOnService(request, this.VALUE);
  }

  createFilterItem(item: CubiqTS.BlotterDefinitionImpl): Promise<boolean> {
    let request = new UiArguments("createFilterItem");
    let arg1 = new FnArg(item, this.VALUE);
    request.args = [arg1];
    return this.runOnService(request, this.VALUE);
  }

  updateFilterItem(item: CubiqTS.BlotterDefinitionImpl): Promise<boolean> {
    let request = new UiArguments("updateFilterItem");
    let arg1 = new FnArg(item, this.VALUE);
    request.args = [arg1];
    return this.runOnService(request, this.VALUE);
  }

  protected runOnService(request: UiArguments, assignable: any = null): Promise<any> {
    return new Promise<any>((res, rej) => {
      this.broker.runOnService(request, PRIMITIVE).then((value: any) => {
        if (value && value.enType && value.enType == ENCODABLE_TYPE_ERRORS) {
          rej(value);
        } else {
          if (assignable && value) {
            value = Object.assign(assignable, value);
          }
          res(value);
        }
      });
    });
  }
}
